@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.tracking-number-column {
  width: 100%;
  font-size: 13px;
  height: 30px;

  &.has-error {
    .icon {
      color: @columns--tracking-number--error--fill-color;
    }
  }
}

.normal-content {
  width: 100%;
  height: 100%;
  display: flex;
}

.icon-wrapper {
  height: 30px;
  width: 20px;
  min-width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon {
  height: 18px;
  width: 18px;
  color: @columns--tracking-number--fill-color;
}

.message {
  .truncate();
  width: 100%;
  line-height: 30px;
  margin-left: 5px;
}
